import { EvtHeader } from "components/header";
import React from "react";
import SkillsForm from "../form";

const CreateSkill = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Grade" />
      <div className="p-6 max-w-2xl">
        <SkillsForm />
      </div>
    </div>
  );
};

export default CreateSkill;
